export default __webpack_public_path__ + "static/media/CD__0005_0001.fe900b1e.png";